import { BORDER, COLOR_TOKEN } from './constants/styles-constants';

export const styles = `
	.oneform {
		background-color: ${COLOR_TOKEN.background.primary} !important;
	}
	.oneform input:-webkit-autofill,
	.oneform textarea:-webkit-autofill,
	.oneform select:-webkit-autofill {
		-webkit-box-shadow: 0 0 0 1000px
			${COLOR_TOKEN.background.primary} inset !important;
		-webkit-text-fill-color: ${COLOR_TOKEN.content.primary} !important;
	}
	.oneform .select label {
		border-radius: ${BORDER.radius.small} !important;
	}
	.oneform .error button {
		border: ${BORDER.size.active} solid ${COLOR_TOKEN.displayTag.error.background} !important;
	}
	.oneform .checkbox.error path  {
		color: ${COLOR_TOKEN.displayTag.error.background} !important;
	}
	.oneform .checkbox.error span span span  {
		position: absolute;
		width: 300px;
		top: 25px;
		left: 0;
	}
	}
	.oneform .card[disabled] {
		opacity: 0.5;
		cursor: default;
	}
	.oneform .card[disabled] div {
		cursor: default;
	}
`;
